//@ts-check
export const ssr = false;
export const trailingSlash = "always";
export const prerender = true;
